import { useParams } from 'react-router-dom';
import TreatmentHistoryList from 'components/UI/organisms/treatment/list/TreatmentHistoryList';

const TreatmentHistory = () => {
  const { id } = useParams();
  return <TreatmentHistoryList mode="patientTreatmentHistoryList" patientId={id} />;
};

export default TreatmentHistory;
